/**
 * Calculate totals from detail rows
 */
export const calculateTotals = (detailRows: MuaHangRecord[] = []) => {
  const tongPSno = detailRows.reduce((sum: number, row: { ps_no_nt: number }) => sum + (row.ps_no_nt || 0), 0);
  const tongPSCo = detailRows.reduce((sum: number, row: { ps_co_nt: number }) => sum + (row.ps_co_nt || 0), 0);

  return {
    tongPSno,
    tongPSCo
  };
};
